import AdminLessons from "../../components/lessons/AdminLessons";

const AdminLessonsPage = () => {
     return(
          <>
          <AdminLessons />
          </>
     )
};
export default  AdminLessonsPage